/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Markers_Add_Marker_LabelInputs */

const en_markers_add_marker_label = /** @type {(inputs: Markers_Add_Marker_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add new marker`)
};

const fr_markers_add_marker_label = /** @type {(inputs: Markers_Add_Marker_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajouter un nouveau marqueur`)
};

const de_markers_add_marker_label = /** @type {(inputs: Markers_Add_Marker_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neuen Marker hinzufügen`)
};

const it_markers_add_marker_label = /** @type {(inputs: Markers_Add_Marker_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiungi nuovo marcatore`)
};

const ru_markers_add_marker_label = /** @type {(inputs: Markers_Add_Marker_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Добавить новый маркер`)
};

const es_markers_add_marker_label = /** @type {(inputs: Markers_Add_Marker_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Añadir nuevo marcador`)
};

const zh_cn2_markers_add_marker_label = /** @type {(inputs: Markers_Add_Marker_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`添加新标记`)
};

const ja_markers_add_marker_label = /** @type {(inputs: Markers_Add_Marker_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しいマーカーを追加`)
};

const hi_markers_add_marker_label = /** @type {(inputs: Markers_Add_Marker_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नया मार्कर जोड़ें`)
};

const pt_pt2_markers_add_marker_label = /** @type {(inputs: Markers_Add_Marker_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adicionar novo marcador`)
};

/**
* | output |
* | --- |
* | "Add new marker" |
*
* @param {Markers_Add_Marker_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const markers_add_marker_label = /** @type {((inputs?: Markers_Add_Marker_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Markers_Add_Marker_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_markers_add_marker_label(inputs)
	if (locale === "de") return de_markers_add_marker_label(inputs)
	if (locale === "it") return it_markers_add_marker_label(inputs)
	if (locale === "ru") return ru_markers_add_marker_label(inputs)
	if (locale === "es") return es_markers_add_marker_label(inputs)
	if (locale === "zh-CN") return zh_cn2_markers_add_marker_label(inputs)
	if (locale === "ja") return ja_markers_add_marker_label(inputs)
	if (locale === "hi") return hi_markers_add_marker_label(inputs)
	if (locale === "pt-PT") return pt_pt2_markers_add_marker_label(inputs)
	return en_markers_add_marker_label(inputs)
});